var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"IconButton",attrs:{"data-hint":_vm.hint,"is-triggerable":_vm.isTriggerable,"id":_vm.id,"tabindex":"0"},on:{"click":_vm.trigger}},[_c('img',{class:'IconButton__icon ' + (_vm.className != '' ? _vm.className : ''),attrs:{"src":require('@/assets/icons/' + (_vm.active ? _vm.iconTriggered : _vm.icon) + '.svg'),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }